import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import AnimateSection from '@/components/base/AnimateSection';

const latestArticles = articles.slice(4, 10);

export default function LatestArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <AnimateSection>
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-12">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {t('home.latestArticles')}
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                {t('home.latestArticlesDesc')}
              </p>
            </div>
          </div>
        </AnimateSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article, index) => (
            <AnimateSection key={article.id} delay={index * 100} animation="animate-fade-in">
              <Link
                to={`/article/${article.id}`}
                className="group bg-background-100 rounded-xl overflow-hidden hover:scale-[1.01] transition-all duration-300 cursor-pointer block"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={article.cover}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    title={article.title}
                  />
                  <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/60 to-transparent">
                    <div className="flex gap-2">
                      {article.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="px-2 py-0.5 bg-background-50/90 backdrop-blur-sm rounded-full text-xs text-primary-600">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-300">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.author}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views.toLocaleString()}
                    </span>
                  </div>
                </div>
              </Link>
            </AnimateSection>
          ))}
        </div>

        <AnimateSection delay={300}>
          <div className="text-center mt-8 md:mt-10">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('home.allArticles')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </AnimateSection>
      </div>
    </section>
  );
}